const UMSG_TYPE = Object.freeze({
  any: 'any',
  none: 'none',
  fn: 'function',
  global: 'global',
});

export default UMSG_TYPE;
